import useSWR from 'swr';
import { fetchData } from '../services/fetch';

/**
 * Chave que governa a propagação de classificação (AD-10).
 *
 * O nome vem do backend (migração 1782600000000-system-setting). Exportada daqui
 * para que os testes não repitam a string.
 */
export const CHAVE_PROPAGACAO = 'classification.propagation.enabled';

/**
 * EG-42 — AD-11: a chave da propagação está ligada?
 *
 * A rota /system-setting nasceu nesta story: não havia nada no backend expondo
 * configuração ao painel, e a AD-11 registra isso — não havia padrão para
 * copiar. Chave de SWR compartilhada, então múltiplos consumidores na mesma tela
 * não multiplicam requisição.
 *
 * Devolve false enquanto carrega e quando a chave não vem na resposta. Falhar
 * fechado é a mesma regra da guarda do backend: um ambiente sem a chave semeada
 * não pode oferecer propagação por omissão. E, do lado da tela, aparecer depois
 * é melhor que aparecer e sumir — o gestor marcaria o checkbox no instante em
 * que ele existe e o veria desaparecer com o valor marcado.
 */
export const usePropagacaoHabilitada = () => {
  const { data } = useSWR('/system-setting', fetchData);

  if (!data) return false;

  const chave = data.find((configuracao) => configuracao.key === CHAVE_PROPAGACAO);

  return chave?.value === 'true';
};
